// FounderOnboardingPage — première connexion : personnalisation obligatoire des identifiants (v5.9.0).
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { founderApi, getFounderToken, setFounderToken } from "@/lib/founderApi";
import { F } from "@/pages/FounderLoginPage";

export default function FounderOnboardingPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!getFounderToken()) { navigate("/founder-login", { replace: true }); return; }
    founderApi.get("/auth/me")
      .then(({ data }) => { if (!data.must_change_credentials) navigate("/founder-partner", { replace: true }); })
      .catch(() => navigate("/founder-login", { replace: true }));
  }, [navigate]);

  const submit = async (e) => {
    if (e) e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Les deux mots de passe ne correspondent pas."); return; }
    setBusy(true);
    try {
      const { data } = await founderApi.post("/auth/credentials", { new_username: username, new_password: password, email: email || undefined });
      setFounderToken(data.token);
      navigate("/founder-partner", { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Impossible d'enregistrer vos identifiants.");
    } finally { setBusy(false); }
  };

  return (
    <div style={F.page} data-testid="founder-onboarding-page">
      <div style={{ ...F.card, width: "min(440px, 94vw)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 42, height: 42, borderRadius: 12, background: "rgba(16,185,129,0.12)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <ShieldCheck size={22} color="#10B981" />
          </div>
          <div>
            <h1 style={{ ...F.h1, margin: 0 }}>Bienvenue dans votre espace AYA</h1>
            <div style={{ fontSize: 13.5, fontWeight: 800, color: "#B8860B" }}>Maître Allegra</div>
          </div>
        </div>
        <p style={{ ...F.sub, margin: "12px 0 6px" }}>
          Pour sécuriser votre accès, veuillez personnaliser vos identifiants avant de continuer.
        </p>
        <label style={F.label}>Nouvel identifiant</label>
        <input data-testid="founder-new-username" style={F.input} value={username} onChange={(e) => setUsername(e.target.value)} placeholder="ex : m.allegra" />
        <label style={F.label}>Nouveau mot de passe</label>
        <input data-testid="founder-new-password" type="password" style={F.input} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="8 caractères min., lettres + chiffres" />
        <label style={F.label}>Confirmer le mot de passe</label>
        <input data-testid="founder-confirm-password" type="password" style={F.input} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirmez le mot de passe" />
        <label style={F.label}>E-mail de récupération (optionnel)</label>
        <input data-testid="founder-email" type="email" style={F.input} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@exemple.com" />
        {error && <div style={F.error} data-testid="founder-onboarding-error">{error}</div>}
        <button type="button" onClick={submit} disabled={busy || !username || !password || !confirm} style={F.btn} data-testid="founder-onboarding-submit">
          {busy ? "Enregistrement…" : "Valider et accéder à mon espace"}
        </button>
        <button type="button" data-testid="founder-onboarding-later"
          onClick={() => { sessionStorage.setItem("aya_founder_onboarding_later", "1"); navigate("/founder-partner", { replace: true }); }}
          style={{ marginTop: 10, width: "100%", padding: "10px 0", borderRadius: 11, border: "1px solid rgba(16,185,129,0.3)", background: "transparent", color: "#6EE7B7", fontSize: 12.5, fontWeight: 700, cursor: "pointer" }}>
          Plus tard — accéder directement à mon espace
        </button>
      </div>
    </div>
  );
}
